export const API_HOST = window.location.origin;
export const API_PATH = "/web/api/v1";
export const API_URL = `${API_HOST}${API_PATH}`;
export const CONTENT_HOST = process.env.CMS_URL;

export const NEW_API_PATH = "/api";
export const NEW_API_URL = `${API_HOST}${NEW_API_PATH}`;

export default {
  API_HOST,
  API_PATH,
  API_URL,
  NEW_API_PATH,
  NEW_API_URL,
};
